import Image from 'next/image';
import { buildImgProps } from 'utils/media';
import type { ComponentsColumnImage } from 'queries/graphql';

export default function ColumnImage({ sectionId, image }: ComponentsColumnImage) {
  return (
    <div id={sectionId} className="columnImage">
      <Image {...buildImgProps(image)} alt={image?.alt} />
    </div>
  );
}
